import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMentionIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#0f1826",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11.0327 7.99972C11.0327 8.59971 10.8548 9.18622 10.5215 9.68509C10.1881 10.184 9.71436 10.5728 9.16004 10.8024C8.60572 11.032 7.99577 11.0921 7.4073 10.975C6.81884 10.858 6.27831 10.5691 5.85405 10.1448C5.42979 9.72054 5.14087 9.18 5.02382 8.59154C4.90677 8.00308 4.96684 7.39312 5.19645 6.83881C5.42605 6.28449 5.81488 5.81071 6.31375 5.47737C6.81263 5.14403 7.39914 4.96611 7.99913 4.96611C8.80369 4.96611 9.5753 5.28573 10.1442 5.85464C10.7131 6.42355 11.0327 7.19515 11.0327 7.99972ZM11.0327 7.99972L11.033 9.29983C11.033 9.75958 11.2157 10.2005 11.5408 10.5256C11.8658 10.8507 12.3068 11.0333 12.7665 11.0333C13.2263 11.0333 13.6672 10.8507 13.9923 10.5256C14.3174 10.2005 14.5 9.75958 14.5 9.29983V7.99971C14.4999 6.53549 14.0055 5.11417 13.0968 3.96604C12.1881 2.81791 10.9183 2.01023 9.49326 1.67385C8.06819 1.33748 6.5713 1.49211 5.24509 2.11269C3.91888 2.73328 2.84105 3.78347 2.18623 5.09312C1.53141 6.40276 1.33795 7.89513 1.63721 9.32845C1.93646 10.7618 2.7109 12.0521 3.83504 12.9903C4.95918 13.9285 6.36717 14.4597 7.8309 14.4978C9.29463 14.5359 10.7284 14.0787 11.8998 13.2002",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgMentionIcon;
